/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmarkFill: {
  name: 'bookmark-fill';
  data: string;
} = {
  name: 'bookmark-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v15.674a2 2 0 0 0 2.55 1.923L12 20.04l5.45 1.557A2 2 0 0 0 20 19.674V4a2 2 0 0 0-2-2H6Z" fill="currentColor"/></svg>`,
};
